const secJcamp4 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SIZE EXCLUSION CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=MILLILITERS
##YUNITS=ARBITRARY UNITS
##FIRSTX=2.08555E+1
##LASTX=2.70598E+1
##MINX=20.8555
##MAXX=27.0598
##MINY=0.0
##MAXY=0.472426
##NPOINTS=376
##FIRSTY=0.00000E+0
##XUNITS=MILLILITERS
##YUNITS=ARBITRARY UNITS
##XYDATA=(XY..XY)
2.08555E+1, 0.00000E+0
2.08720E+1, 6.47883E-3
2.08886E+1, 9.23873E-4
2.09051E+1, 0.00000E+0
2.09217E+1, 0.00000E+0
2.09382E+1, 0.00000E+0
2.09548E+1, 0.00000E+0
2.09713E+1, 0.00000E+0
2.09878E+1, 0.00000E+0
2.10044E+1, 0.00000E+0
2.10209E+1, 0.00000E+0
2.10375E+1, 0.00000E+0
2.10540E+1, 0.00000E+0
2.10706E+1, 0.00000E+0
2.10871E+1, 0.00000E+0
2.11037E+1, 0.00000E+0
2.11202E+1, 0.00000E+0
2.11367E+1, 0.00000E+0
2.11533E+1, 0.00000E+0
2.11698E+1, 0.00000E+0
2.11864E+1, 0.00000E+0
2.12029E+1, 0.00000E+0
2.12195E+1, 0.00000E+0
2.12360E+1, 0.00000E+0
2.12526E+1, 0.00000E+0
2.12691E+1, 0.00000E+0
2.12856E+1, 0.00000E+0
2.13022E+1, 0.00000E+0
2.13187E+1, 0.00000E+0
2.13353E+1, 0.00000E+0
2.13518E+1, 0.00000E+0
2.13684E+1, 0.00000E+0
2.13849E+1, 0.00000E+0
2.14015E+1, 0.00000E+0
2.14180E+1, 0.00000E+0
2.14346E+1, 0.00000E+0
2.14511E+1, 0.00000E+0
2.14676E+1, 0.00000E+0
2.14842E+1, 0.00000E+0
2.15007E+1, 0.00000E+0
2.15173E+1, 0.00000E+0
2.15338E+1, 0.00000E+0
2.15504E+1, 0.00000E+0
2.15669E+1, 0.00000E+0
2.15835E+1, 0.00000E+0
2.16000E+1, 0.00000E+0
2.16165E+1, 0.00000E+0
2.16331E+1, 0.00000E+0
2.16496E+1, 0.00000E+0
2.16662E+1, 0.00000E+0
2.16827E+1, 0.00000E+0
2.16993E+1, 0.00000E+0
2.17158E+1, 0.00000E+0
2.17324E+1, 0.00000E+0
2.17489E+1, 0.00000E+0
2.17654E+1, 0.00000E+0
2.17820E+1, 0.00000E+0
2.17985E+1, 0.00000E+0
2.18151E+1, 0.00000E+0
2.18316E+1, 0.00000E+0
2.18482E+1, 0.00000E+0
2.18647E+1, 0.00000E+0
2.18813E+1, 0.00000E+0
2.18978E+1, 0.00000E+0
2.19144E+1, 0.00000E+0
2.19309E+1, 0.00000E+0
2.19474E+1, 0.00000E+0
2.19640E+1, 0.00000E+0
2.19805E+1, 0.00000E+0
2.19971E+1, 0.00000E+0
2.20136E+1, 0.00000E+0
2.20302E+1, 0.00000E+0
2.20467E+1, 0.00000E+0
2.20633E+1, 0.00000E+0
2.20798E+1, 0.00000E+0
2.20963E+1, 0.00000E+0
2.21129E+1, 3.23376E-3
2.21294E+1, 9.86113E-3
2.21460E+1, 1.09612E-2
2.21625E+1, 1.57153E-2
2.21791E+1, 2.17482E-2
2.21956E+1, 2.47102E-2
2.22122E+1, 3.95239E-2
2.22287E+1, 5.12024E-2
2.22452E+1, 6.39332E-2
2.22618E+1, 7.07847E-2
2.22783E+1, 7.19831E-2
2.22949E+1, 7.31507E-2
2.23114E+1, 7.65929E-2
2.23280E+1, 8.59591E-2
2.23445E+1, 9.76030E-2
2.23611E+1, 1.12174E-1
2.23776E+1, 1.28604E-1
2.23942E+1, 1.42380E-1
2.24107E+1, 1.47624E-1
2.24272E+1, 1.54672E-1
2.24438E+1, 1.64409E-1
2.24603E+1, 1.71789E-1
2.24769E+1, 1.83595E-1
2.24934E+1, 1.90771E-1
2.25100E+1, 1.98231E-1
2.25265E+1, 2.10005E-1
2.25431E+1, 2.11984E-1
2.25596E+1, 2.19967E-1
2.25761E+1, 2.31644E-1
2.25927E+1, 2.40500E-1
2.26092E+1, 2.56281E-1
2.26258E+1, 2.66060E-1
2.26423E+1, 2.76426E-1
2.26589E+1, 2.89615E-1
2.26754E+1, 3.02011E-1
2.26920E+1, 3.12639E-1
2.27085E+1, 3.14264E-1
2.27250E+1, 3.22438E-1
2.27416E+1, 3.31515E-1
2.27581E+1, 3.41325E-1
2.27747E+1, 3.44188E-1
2.27912E+1, 3.50930E-1
2.28078E+1, 3.65246E-1
2.28243E+1, 3.74774E-1
2.28409E+1, 3.93282E-1
2.28574E+1, 3.98226E-1
2.28740E+1, 3.90690E-1
2.28905E+1, 3.98190E-1
2.29070E+1, 4.07108E-1
2.29236E+1, 4.12217E-1
2.29401E+1, 4.18419E-1
2.29567E+1, 4.31223E-1
2.29732E+1, 4.36351E-1
2.29898E+1, 4.29214E-1
2.30063E+1, 4.36199E-1
2.30229E+1, 4.44728E-1
2.30394E+1, 4.44847E-1
2.30559E+1, 4.48098E-1
2.30725E+1, 4.53206E-1
2.30890E+1, 4.58049E-1
2.31056E+1, 4.53617E-1
2.31221E+1, 4.58187E-1
2.31387E+1, 4.68484E-1
2.31552E+1, 4.68642E-1
2.31718E+1, 4.71347E-1
2.31883E+1, 4.72426E-1
2.32049E+1, 4.70963E-1
2.32214E+1, 4.68139E-1
2.32379E+1, 4.65239E-1
2.32545E+1, 4.65915E-1
2.32710E+1, 4.65485E-1
2.32876E+1, 4.65787E-1
2.33041E+1, 4.65136E-1
2.33207E+1, 4.66763E-1
2.33372E+1, 4.65398E-1
2.33538E+1, 4.64944E-1
2.33703E+1, 4.64778E-1
2.33868E+1, 4.64110E-1
2.34034E+1, 4.63559E-1
2.34199E+1, 4.60812E-1
2.34365E+1, 4.55529E-1
2.34530E+1, 4.51192E-1
2.34696E+1, 4.50726E-1
2.34861E+1, 4.46002E-1
2.35027E+1, 4.40160E-1
2.35192E+1, 4.38124E-1
2.35357E+1, 4.34955E-1
2.35523E+1, 4.32270E-1
2.35688E+1, 4.30437E-1
2.35854E+1, 4.25686E-1
2.36019E+1, 4.19569E-1
2.36185E+1, 4.16814E-1
2.36350E+1, 4.09721E-1
2.36516E+1, 4.00287E-1
2.36681E+1, 3.96363E-1
2.36847E+1, 3.95529E-1
2.37012E+1, 3.93925E-1
2.37177E+1, 3.87095E-1
2.37343E+1, 3.75961E-1
2.37508E+1, 3.62973E-1
2.37674E+1, 3.59527E-1
2.37839E+1, 3.61180E-1
2.38005E+1, 3.49352E-1
2.38170E+1, 3.35088E-1
2.38336E+1, 3.30036E-1
2.38501E+1, 3.28645E-1
2.38666E+1, 3.22308E-1
2.38832E+1, 3.06874E-1
2.38997E+1, 2.95588E-1
2.39163E+1, 2.89936E-1
2.39328E+1, 2.79494E-1
2.39494E+1, 2.67695E-1
2.39659E+1, 2.54394E-1
2.39825E+1, 2.45644E-1
2.39990E+1, 2.44753E-1
2.40155E+1, 2.40274E-1
2.40321E+1, 2.33624E-1
2.40486E+1, 2.28270E-1
2.40652E+1, 2.20623E-1
2.40817E+1, 2.09072E-1
2.40983E+1, 1.96522E-1
2.41148E+1, 1.80223E-1
2.41314E+1, 1.62355E-1
2.41479E+1, 1.54047E-1
2.41645E+1, 1.46735E-1
2.41810E+1, 1.38686E-1
2.41975E+1, 1.32939E-1
2.42141E+1, 1.25169E-1
2.42306E+1, 1.14122E-1
2.42472E+1, 9.82308E-2
2.42637E+1, 8.39633E-2
2.42803E+1, 7.56610E-2
2.42968E+1, 7.10109E-2
2.43134E+1, 6.29317E-2
2.43299E+1, 4.67369E-2
2.43464E+1, 3.08422E-2
2.43630E+1, 2.10877E-2
2.43795E+1, 1.53513E-2
2.43961E+1, 1.03631E-2
2.44126E+1, 5.40850E-3
2.44292E+1, 0.00000E+0
2.44457E+1, 0.00000E+0
2.44623E+1, 0.00000E+0
2.44788E+1, 0.00000E+0
2.44953E+1, 0.00000E+0
2.45119E+1, 0.00000E+0
2.45284E+1, 0.00000E+0
2.45450E+1, 0.00000E+0
2.45615E+1, 0.00000E+0
2.45781E+1, 0.00000E+0
2.45946E+1, 0.00000E+0
2.46112E+1, 0.00000E+0
2.46277E+1, 0.00000E+0
2.46443E+1, 0.00000E+0
2.46608E+1, 0.00000E+0
2.46773E+1, 0.00000E+0
2.46939E+1, 0.00000E+0
2.47104E+1, 0.00000E+0
2.47270E+1, 0.00000E+0
2.47435E+1, 0.00000E+0
2.47601E+1, 0.00000E+0
2.47766E+1, 0.00000E+0
2.47932E+1, 0.00000E+0
2.48097E+1, 0.00000E+0
2.48262E+1, 0.00000E+0
2.48428E+1, 0.00000E+0
2.48593E+1, 0.00000E+0
2.48759E+1, 0.00000E+0
2.48924E+1, 0.00000E+0
2.49090E+1, 0.00000E+0
2.49255E+1, 0.00000E+0
2.49421E+1, 0.00000E+0
2.49586E+1, 0.00000E+0
2.49751E+1, 0.00000E+0
2.49917E+1, 0.00000E+0
2.50082E+1, 0.00000E+0
2.50248E+1, 0.00000E+0
2.50413E+1, 0.00000E+0
2.50579E+1, 0.00000E+0
2.50744E+1, 0.00000E+0
2.50910E+1, 0.00000E+0
2.51075E+1, 0.00000E+0
2.51241E+1, 0.00000E+0
2.51406E+1, 0.00000E+0
2.51571E+1, 0.00000E+0
2.51737E+1, 0.00000E+0
2.51902E+1, 0.00000E+0
2.52068E+1, 0.00000E+0
2.52233E+1, 0.00000E+0
2.52399E+1, 0.00000E+0
2.52564E+1, 0.00000E+0
2.52730E+1, 0.00000E+0
2.52895E+1, 0.00000E+0
2.53060E+1, 0.00000E+0
2.53226E+1, 0.00000E+0
2.53391E+1, 0.00000E+0
2.53557E+1, 0.00000E+0
2.53722E+1, 0.00000E+0
2.53888E+1, 0.00000E+0
2.54053E+1, 0.00000E+0
2.54219E+1, 0.00000E+0
2.54384E+1, 0.00000E+0
2.54550E+1, 0.00000E+0
2.54715E+1, 0.00000E+0
2.54880E+1, 0.00000E+0
2.55046E+1, 0.00000E+0
2.55211E+1, 0.00000E+0
2.55377E+1, 0.00000E+0
2.55542E+1, 0.00000E+0
2.55708E+1, 0.00000E+0
2.55873E+1, 0.00000E+0
2.56039E+1, 0.00000E+0
2.56204E+1, 0.00000E+0
2.56369E+1, 0.00000E+0
2.56535E+1, 0.00000E+0
2.56700E+1, 0.00000E+0
2.56866E+1, 0.00000E+0
2.57031E+1, 0.00000E+0
2.57197E+1, 0.00000E+0
2.57362E+1, 0.00000E+0
2.57528E+1, 0.00000E+0
2.57693E+1, 0.00000E+0
2.57858E+1, 0.00000E+0
2.58024E+1, 0.00000E+0
2.58189E+1, 0.00000E+0
2.58355E+1, 0.00000E+0
2.58520E+1, 0.00000E+0
2.58686E+1, 0.00000E+0
2.58851E+1, 0.00000E+0
2.59017E+1, 0.00000E+0
2.59182E+1, 0.00000E+0
2.59348E+1, 0.00000E+0
2.59513E+1, 0.00000E+0
2.59678E+1, 0.00000E+0
2.59844E+1, 0.00000E+0
2.60009E+1, 0.00000E+0
2.60175E+1, 0.00000E+0
2.60340E+1, 0.00000E+0
2.60506E+1, 0.00000E+0
2.60671E+1, 0.00000E+0
2.60837E+1, 0.00000E+0
2.61002E+1, 0.00000E+0
2.61167E+1, 0.00000E+0
2.61333E+1, 0.00000E+0
2.61498E+1, 0.00000E+0
2.61664E+1, 0.00000E+0
2.61829E+1, 0.00000E+0
2.61995E+1, 0.00000E+0
2.62160E+1, 0.00000E+0
2.62326E+1, 0.00000E+0
2.62491E+1, 0.00000E+0
2.62656E+1, 0.00000E+0
2.62822E+1, 0.00000E+0
2.62987E+1, 0.00000E+0
2.63153E+1, 0.00000E+0
2.63318E+1, 0.00000E+0
2.63484E+1, 0.00000E+0
2.63649E+1, 0.00000E+0
2.63815E+1, 0.00000E+0
2.63980E+1, 0.00000E+0
2.64146E+1, 0.00000E+0
2.64311E+1, 0.00000E+0
2.64476E+1, 0.00000E+0
2.64642E+1, 0.00000E+0
2.64807E+1, 0.00000E+0
2.64973E+1, 0.00000E+0
2.65138E+1, 0.00000E+0
2.65304E+1, 0.00000E+0
2.65469E+1, 0.00000E+0
2.65635E+1, 0.00000E+0
2.65800E+1, 0.00000E+0
2.65965E+1, 0.00000E+0
2.66131E+1, 0.00000E+0
2.66296E+1, 0.00000E+0
2.66462E+1, 0.00000E+0
2.66627E+1, 0.00000E+0
2.66793E+1, 0.00000E+0
2.66958E+1, 0.00000E+0
2.67124E+1, 0.00000E+0
2.67289E+1, 0.00000E+0
2.67454E+1, 0.00000E+0
2.67620E+1, 0.00000E+0
2.67785E+1, 0.00000E+0
2.67951E+1, 0.00000E+0
2.68116E+1, 0.00000E+0
2.68282E+1, 0.00000E+0
2.68447E+1, 0.00000E+0
2.68613E+1, 0.00000E+0
2.68778E+1, 0.00000E+0
2.68944E+1, 0.00000E+0
2.69109E+1, 0.00000E+0
2.69274E+1, 0.00000E+0
2.69440E+1, 0.00000E+0
2.69605E+1, 0.00000E+0
2.69771E+1, 0.00000E+0
2.69936E+1, 0.00000E+0
2.70102E+1, 0.00000E+0
2.70267E+1, 0.00000E+0
2.70433E+1, 0.00000E+0
2.70598E+1, 5.55112E-17
##END=$$ End of the data block


`;

export default secJcamp4;
